// extracted by mini-css-extract-plugin
module.exports = {"search":"BlogSearch_search__1q0s8"};